// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"78ad97d7","453":"c5ac57fc","750":"423da36d"}[chunkId] + ".chunk.js";
};